import React,{ useRef } from 'react'
import { DocumentEditorContainerComponent, Toolbar } from '@syncfusion/ej2-react-documenteditor';
DocumentEditorContainerComponent.Inject(Toolbar);

function EditDriveFile() {

  const documentEditorRef = useRef(null);

  const handleSave = () => {
    if (documentEditorRef.current) {
      // Save the document in DOCX format
      documentEditorRef.current.documentEditor.save('MyDocument', 'Docx');
    }
  };

  return (
    <div>
    <button onClick={handleSave}>Save as DOCX</button>
    <DocumentEditorContainerComponent 
      height='100%' 
      ref={documentEditorRef}
      style={{ 'height': '100vh' }} 
      serviceUrl="https://fcplfmsbucket.s3.ap-south-1.amazonaws.com/DEPLOY_NODE_JS_APP_ON_AWS.docx" 
      enableToolbar={true}
      toolbarItems={[
        'Undo', 'Redo', 'Image', 'Table', 'Header', 'Footer', 'PageSetup', 'PageNumber',
        'Break', 'Find', 'LocalClipboard', 'RestrictEditing', 'TrackChanges', 
        'FormFields',
      ]}
      />
      </div>
  )
}

export default EditDriveFile